import axios from 'axios'
// import constant from './constant'; // 假设你有一个 constant.js 文件
const token = 'your_csrf_token'

const axiosInstance = axios.create({
  // baseURL: constant.webBaseURL,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN': token,
    'Content-Type': 'application/x-www-form-urlencoded' // 添加新的请求头
  }
})
// 添加请求拦截器
axiosInstance.interceptors.request.use(
  (config) => {
    // 检查请求方法是否为 POST
    if (config.method === 'post' && config.data) {
      const formData = new FormData()

      // 将 config.data 中的所有参数添加到 FormData
      for (const key in config.data) {
        if (Object.prototype.hasOwnProperty.call(config.data, key)) {
          formData.append(key, config.data[key])
        }
      }

      // 将 FormData 赋值给 config.data
      config.data = formData
    }
    return config
  },
  (error) => {
    // console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 添加响应拦截器
axiosInstance.interceptors.response.use(
  (response) => {
    if (response.data.status !== 0) {
      alert(response.data.msg)
      // this.$bvToast.toast(`请求错误`, {
      //   title: response.data.msg,
      //   autoHideDelay: 5000
      // })
    }
    return response.data
  },
  (error) => {
    // 对响应错误做点什么
    // console.error('响应错误:', error)
    // 可以根据错误状态码进行不同处理
    if (error.response) {
      // 服务器响应了状态码，但状态码超出了 2xx 的范围
      // console.error('错误状态码:', error.response.status)
      // console.error('错误数据:', error.response.data)
    } else if (error.request) {
      // 请求已发出，但没有收到响应
      // console.error('请求未收到响应:', error.request)
    } else {
      // 其他错误
      // console.error('错误信息:', error.message)
    }
    return Promise.reject(error)
  }
)

export default axiosInstance
